<template>
  <qrcode-stream
    class="qrcode-reader"
    :camera="camera"
    @decode="qrDecoded"
    @init="onInit"
  >
    <img
      v-show="!success && initialized"
      src="../assets/img/qr-overlay-2.png"
      width="35%"
    />
    <div v-show="success" class="success-checkmark">
      <div class="check-icon">
        <span class="icon-line line-tip"></span>
        <span class="icon-line line-long"></span>
        <div class="icon-circle"></div>
        <div class="icon-fix"></div>
      </div>
    </div>
  </qrcode-stream>
</template>

<script>
  import { QrcodeStream } from "vue-qrcode-reader";

  export default {
    name: "QrScanner",
    components: {
      QrcodeStream,
    },
    data() {
      return {
        success: false,
        camera: process.env.VUE_APP_PREFERED_CAMERA,
        initialized: false,
      };
    },
    methods: {
      qrDecoded(str) {
        this.success = true;
        setTimeout(() => {
          this.pause();
          this.$emit("scan", str);

          setTimeout(() => {
            this.success = false;
            this.unpause();
          }, 500);
        }, 1000);
      },
      async onInit(promise) {
        try {
          await promise;
          this.initialized = true;
          this.$emit("initialized");
        } catch (error) {
          if (error.name === "NotAllowedError") {
            this.$emit(
              "error",
              "ERROR: you need to grant camera access permisson"
            );
          } else if (error.name === "NotFoundError") {
            this.$emit("error", "ERROR: no camera on this device");
          } else if (error.name === "NotSupportedError") {
            this.$emit(
              "error",
              "ERROR: secure context required (HTTPS, localhost)"
            );
          } else if (error.name === "NotReadableError") {
            this.$emit("error", "ERROR: is the camera already in use?");
          } else if (error.name === "OverconstrainedError") {
            this.$emit("error", "ERROR: installed cameras are not suitable");
          } else if (error.name === "StreamApiNotSupportedError") {
            this.$emit(
              "error",
              "ERROR: Stream API is not supported in this browser"
            );
          } else {
            this.$emit(
              "error",
              "ERROR: Unerwarteter Fehler beim initialisieren der Kamera. " +
                JSON.stringify(error)
            );
          }
        }
      },
      unpause() {
        this.camera = process.env.VUE_APP_PREFERED_CAMERA;
      },
      pause() {
        this.camera = "off";
      },
    },
  };
</script>

<style lang="scss">
  .qrcode-reader {
    .camera {
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      max-height: 500px;
    }

    img,
    .success-checkmark {
      position: absolute !important;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .success-checkmark {
      width: 80px;
      height: 115px;
      margin: 0 auto;

      .check-icon {
        width: 80px;
        height: 80px;
        position: relative;
        border-radius: 50%;
        box-sizing: content-box;
        border: 4px solid #4caf50;

        &::before {
          top: 3px;
          left: -2px;
          width: 30px;
          transform-origin: 100% 50%;
          border-radius: 100px 0 0 100px;
        }

        &::after {
          top: 0;
          left: 30px;
          width: 60px;
          transform-origin: 0 50%;
          border-radius: 0 100px 100px 0;
          animation: rotate-circle 4.25s ease-in;
        }

        &::before,
        &::after {
          content: "";
          height: 100px;
          position: absolute;
          transform: rotate(-45deg);
        }

        .icon-line {
          height: 5px;
          background-color: #4caf50;
          display: block;
          border-radius: 2px;
          position: absolute;
          z-index: 10;

          &.line-tip {
            top: 46px;
            left: 14px;
            width: 25px;
            transform: rotate(45deg);
            animation: icon-line-tip 0.75s;
          }

          &.line-long {
            top: 38px;
            right: 8px;
            width: 47px;
            transform: rotate(-45deg);
            animation: icon-line-long 0.75s;
          }
        }

        .icon-circle {
          top: -4px;
          left: -4px;
          z-index: 10;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          position: absolute;
          box-sizing: content-box;
          border: 4px solid rgba(76, 175, 80, 0.5);
        }

        .icon-fix {
          top: 8px;
          width: 5px;
          left: 26px;
          z-index: 1;
          height: 85px;
          position: absolute;
          transform: rotate(-45deg);
          background-color: transparent;
        }
      }
    }

    @keyframes rotate-circle {
      0% {
        transform: rotate(-45deg);
      }
      5% {
        transform: rotate(-45deg);
      }
      12% {
        transform: rotate(-405deg);
      }
      100% {
        transform: rotate(-405deg);
      }
    }

    @keyframes icon-line-tip {
      0% {
        width: 0;
        left: 1px;
        top: 19px;
      }
      54% {
        width: 0;
        left: 1px;
        top: 19px;
      }
      70% {
        width: 50px;
        left: -8px;
        top: 37px;
      }
      84% {
        width: 17px;
        left: 21px;
        top: 48px;
      }
      100% {
        width: 25px;
        left: 14px;
        top: 45px;
      }
    }

    @keyframes icon-line-long {
      0% {
        width: 0;
        right: 46px;
        top: 54px;
      }
      65% {
        width: 0;
        right: 46px;
        top: 54px;
      }
      84% {
        width: 55px;
        right: 0px;
        top: 35px;
      }
      100% {
        width: 47px;
        right: 8px;
        top: 38px;
      }
    }
  }
</style>
